export const getPlotSize = (plotSize: number | null, plotSuffix = true) => {
  if (plotSize === null) return "";
  const isHa = plotSize >= 10000;
  const formattedSize = isHa ? (plotSize / 10000).toFixed(1) : plotSize;
  const suffix = isHa ? " ha" : " m²";
  return `${formattedSize}${suffix}${plotSuffix ? " tomt" : ""}`;
};

// FIXME: Dirty code. Need to extract formatter functions and reuse cleanly
export function getPlotSizeRange(
  min: number | null,
  max: number | null,
  plotSuffix = true,
) {
  // Both min and max exist
  if (min && max) {
    const isHa = min >= 10_000 && max >= 10_000;
    const suffix = isHa ? " ha" : " m²";

    const [formattedMin, formattedMax] = [min, max].map(x => {
      const number = isHa
        ? (x / 10_000).toFixed(1)
        : x;
      return number.toLocaleString("sv-SE");
    })

    if (min === max) return `${formattedMin} ${suffix}${plotSuffix ? " tomt" : ""}`
    return `${formattedMin} - ${formattedMax} ${suffix}${plotSuffix ? " tomt" : ""}`
  }

  // Either min or max exist but not both
  const isHa = (min && min >= 10_000) || (max && max >= 10_000);
  const suffix = isHa ? " ha" : " m²";
  
  if (min) {
    const number = isHa
      ? (min / 10_000).toFixed(1)
      : min;
    const formattedMin = number.toLocaleString("sv-SE")

    return `Från ${formattedMin} ${suffix}${plotSuffix ? " tomt" : ""}`
  }
  if (max) {
    const number = isHa
      ? (max / 10_000).toFixed(1)
      : max;
    const formattedMax = number.toLocaleString("sv-SE")

    return `Upp till ${formattedMax} ${suffix}${plotSuffix ? " tomt" : ""}`
  }

  return "";
}
